module.exports = "<app-master-slider></app-master-slider>"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-news/master-news.component.html
// module id = ./src/app/master/master-news/master-news.component.html
// module chunks = main